window.$ && $(document).ready(function() {
  instagramGalleryMethod();
  jdgmCarouselArrow();
  klarnaModal();
  mobileFeaturedIcon();
  footerMenuMobile();
  $('.instagram_product_handle').each(function() {
    var product_handle_str = $(this).attr('data');
    var product_info = getProductInfo(product_handle_str, $(this), getInstagramProductInfo);
  });
  $(document).on('click', '.coupon-copy-btn', function(e) {
    copyMethod($(this).attr('data'));
    $(this).text('Copied');
  });
  $(window).scroll(function(){
    if($(".product-form .product-form__submit").length == 0) {
      return
    }
    const topData = $(".product-form .product-form__submit").length > 0 ? $(".product-form .product-form__submit")[0].getBoundingClientRect().top : 300
    const topDataChange = $(window).scrollTop()> Math.ceil(topData);
    if (Math.ceil(topData)<50) {
      if($(window).width()>990) {
        $('.sticky_addcart').addClass('active');
      } else {
          $('.sticky_addcart').addClass('active');
      }
    }else{
      $('.sticky_addcart').removeClass('active');
    }
  });

  $('.select_variant_id').change(function() {
    var c_selected_option = $(this).find('option:selected');
    let c_variant_id = c_selected_option.data('variant_id');
    const topData = $(document).scrollTop();
    $('#label_variant_id_'+c_variant_id).click();
    $(document).scrollTop(topData);
  });
    
  $('.btn-add-stickycart').on( 'click', function() {
    $('.btn-add-stickycart').attr("disabled", 'disabled').addClass("btn--loader-active");
    $('.product-form .product-form__submit ').click();
    setTimeout(function() {
      $('.btn-add-stickycart').removeAttr("disabled").css('pointer-events', 'auto').removeClass("btn--loader-active");
    }, 2000)
  });
  
  $(document).on('click', ".apply-discount-btn", function(e) {
    e.preventDefault()
    applyDiscount($(this).parent('.cart-sidebar-discount').find("#discount-code-input").val());
  }).on('click', ".applied-discount-code .applied-discount-code-wrapper,#clear-discount-btn", function(e) {
    e.preventDefault();
    let current_code = $(this).attr('data');
    clearDiscount(current_code);
  });
  if($('#product_spu_title').length){
    ajaxGetSections('template--18286184366154__section_instagram_gallery_page_VBV6Qc', $('.shopify-app-block[id*=judge_me_reviews_review_widget]').parents('.shopify-section'),getProductnstagram);
  }
  getShippingRate();
})
window.shipping_fee = 0;
window.money_format = '${{amount}}';
window.settings_new = {moneyFormat:'\$\{\{ amount \}\}'};
Shopify.formatMoney = function(cents, format) {
  var value = '',
  placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
  formatString = (format || this.money_format);

  if (typeof cents == 'string') {
    cents = cents.replace('.','');
  }

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

var slickDom = null;
function instagramGalleryMethod() { // 相册页面功能
  if($('.section-instagram-gallery').length <= 0) {
    return;
  }
  
  $(document).on('click', '.image-list-item', function() {
      let indexData = $(this).find('.img-box').attr('index');
      slickDom && slickDom.slick('slickGoTo', Number(indexData)-1);
      const curDom = $('.image-list-slick-modal .image-list-item-video');
      for(let i = 0; i < curDom.length; i ++){
        curDom[i].addEventListener('pause', function() {
          $(curDom[i]).siblings('.video-icon').show();
        })
        curDom[i].addEventListener('play', function() {
          $(curDom[i]).siblings('.video-icon').hide();
          const curDom1 = $('.image-list-slick-modal .image-list-item-video');
          for(let i = 0; i < curDom1.length; i ++){
            const curClass =  $(curDom1[i]).parent().attr('class')
            if ($(curDom1[i]) && $(curDom1[i]).length > 0) {
             if (curClass.indexOf('slick-active') == 0){
                 $(curDom1[i])[0].pause()
             }
           }
          }
        })
        curDom[i].addEventListener('ended', function() {
          $(curDom[i]).siblings('.video-icon').show();
        })
      }
      setTimeout(function() {
        $('.image-list-slick-modal .video-icon').show();
      }, 800);
      $('body').addClass('cartover');
      $(".image-list-slick-modal").show();
  })
  $(document).on('click', '.slick-modal-mask-close', function() {
      $(".image-list-slick-modal").hide();
      $('body').removeClass('cartover');
      pauseVideo();
  })

  $('.image-list-slick-modal .slick-modal-mask-close').on('touchend', function(e) {
     $(".image-list-slick-modal").hide();
     $('body').removeClass('cartover');
     pauseVideo();
     e.preventDefault();
 })
  $(document).on('click', '.image-list-slick-modal .video-icon', function() {
    pauseVideo();
    const $domVideo = $(this).siblings('video');
    if ($domVideo && $domVideo.length > 0) {
      $domVideo[0].play();
      $(this).hide();
    }
  })
  $(document).on('click', '.section-instagram-gallery .next-slide', function(e) {
     pauseVideo();
     if (e && e.preventDefault){
         e.preventDefault();
     } else {
        window.event.returnValue = false;
     }
     if(e && e.stopPropagation){
        e.stopPropagation()
     }
     return false;
  })
  $(document).on('click', '.section-instagram-gallery .prev-slide', function(e) {
     pauseVideo();
     if (e && e.preventDefault){
         e.preventDefault();
     } else {
        window.event.returnValue = false;
     }
     if (e && e.stopPropagation){
       e.stopPropagation()
     }
     return false;
  })
  function pauseVideo() {
    const curDom = $('.image-list-slick-modal .image-list-item-video');
    for(let i = 0; i < curDom.length; i ++){
     if ($(curDom[i]) && $(curDom[i]).length > 0) {
       $(curDom[i])[0].pause()
     }
    }
  }
  if ($('.image-list-slick-modal .image-list-slick .img-box-outer').length > 1) {
    slickDom =  $('.image-list-slick-modal .image-list-slick').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: isAppleMobile() ?  false : true, 
      infinite: true,
      vertical: false,
      verticalSwiping: false,
      centerMode: false,
      centerPadding: 0,
      //prevArrow:'<span class="prev-slide"><i class="fa fa-angle-left"></i></span>',
      //nextArrow:'<span class="next-slide"><i class="fa fa-angle-right"></i></span>',
      prevArrow:'<span class="prev-slide" aria-label="prev"><svg fill="none" width="16" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></span>',
      nextArrow:'<span class="next-slide" aria-label="next"><svg fill="none" width="16" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></span>',
      focusOnSelect: false,
      swipe: isAppleMobile() ?  false : true,
      //lazyLoad:'ondemand'
    })
  }
  $('.js_section_instagram_gallery .image-list').slick({
    slidesToShow:  $(window).width() > 990 ? 4 : 2.05,
    slidesToScroll: $(window).width() > 990 ? 4 : 1,
    dots: false,
    arrows: true,
    infinite: true,
    vertical: false,
    verticalSwiping: false,
    centerMode: false,
    centerPadding: 0,
    prevArrow:'<button type="button" class="prev-slide" aria-label="prev"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    nextArrow:'<button type="button" class="next-slide" aria-label="next"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    //prevArrow:'<button type="button" class="prev-slide"><svg fill="none" width="23" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></button>',
    //nextArrow:'<button type="button" class="next-slide"><svg fill="none" width="23" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></i></button>',
    focusOnSelect: false,
    initialSlide: $(window).width() > 990 ? 0 : 0,
    //lazyLoad:'ondemand',
  })
  $('.js_section_instagram_gallery_index .image-list').slick({
    slidesToShow:  $(window).width() > 990 ? 1.01 : 2.03,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: true,
    vertical: false,
    verticalSwiping: false,
    centerMode: true,
    centerPadding: $(window).width() > 990 ? 0 : '0px',
    //prevArrow:'<button type="button" class="prev-slide"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    //nextArrow:'<button type="button" class="next-slide"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    prevArrow:'<button type="button" class="prev-slide" aria-label="prev"><svg fill="none" width="23" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></button>',
    nextArrow:'<button type="button" class="next-slide" aria-label="next"><svg fill="none" width="23" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></i></button>',
    focusOnSelect: false,
    initialSlide: 1,
    adaptiveHeight: false
    //lazyLoad:'ondemand',
  })
  slickDom && slickDom.on("afterChange", function(e, slick, currentSlide){
   if (e && e.preventDefault){
       e.preventDefault();
   } else {
      window.event.returnValue = false;
   }
   if (e && e.stopPropagation){
     e.stopPropagation()
   }
  })
  // const height1 = $('.image-list-item').width();
  // $(".image-list-item .img-box img").css('height', height1+'px');
  // $(".image-list").css('opacity', 1);
  let  height1 = $('.image-list-item').width() < $('.js_section_instagram_gallery').width() ? $('.js_section_instagram_gallery').width()/4 : $('.image-list-item').width();
  if ($(window).width() < 990) {
    height1 = $('.section-instagram-gallery .container .row').width()/2;
    $(".image-list .slick-list .image-list-item").length === 1 && $(".image-list .slick-list").css("display", "flex").css("justify-content", "center");
  }
  console.log('height123',height1)
  const isHaveClassDom = $('.section-instagram-gallery .js_section_instagram_gallery_index');
  if (isHaveClassDom.length > 0) {
     $(".image-list-item .img-box img").css('height', (height1/2)+'px');
     const imageDom = $(".image-list-item-outer");
     const isPc = $(window).width() > 990 ? true : false;
     for(let i=0; i <imageDom.length; i ++) {
        const firstDom = $(imageDom[i]).children().eq(0); //第一个元素
        if (isPc){
          firstDom.find('.img-box img').css('height', (height1+20)+'px');
        } else {
          firstDom.find('.img-box img').css('height', (height1+10)+'px');
        }
    }
  } else {
    $(".image-list-item .img-box img").css('height', height1+'px').css('width', height1+'px');
  }
  $(".image-list").css('opacity', 1);
  ajaxAddCartByForm('form.compare-form-cart');
}
// 是否为 iPhone
function isAppleMobile() {
  return (navigator.platform.indexOf('iPhone') != -1);
}
function jdgmCarouselArrow() {
  const container =  $('.jdgm-container .jdgm-carousel__arrows');
  const leftArrow = container.find('.jdgm-carousel__left-arrow');
  const rightArrow = container.find('.jdgm-carousel__right-arrow');
  const arrowDom1 = container.find('.jdgm-carousel__left-arrow .fa-arrow-left');
  const arrowDom2 = container.find('.jdgm-carousel__right-arrow .fa-arrow-right');
  arrowDom1.length==0 && leftArrow.append(`<svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg>`)
  arrowDom2.length==0 &&  rightArrow.append(`<svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg>`)
}
function getProductnstagram(section_filename,ele_obj,data){
  console.log('data', data);
  var product_handle_contain = 0;
  var related_product_new = $('#product_spu_title');
  var related_product_handle = related_product_new.attr('product_handle');
  var related_product_handle_arr = related_product_handle.split(',');
  let $res_html = $(data[section_filename]);
  let current_product_sku_ele = related_product_new;
  $res_html.find('.instagram_product_handle').each(function() {
    var product_handle_spu = $(this).attr('spuattr');
    if(product_handle_spu != ''){
      if(current_product_sku_ele.hasClass(product_handle_spu)){
        product_handle_contain = 1;
        let product_handle_string = $(this).attr('product_handle');
        $(this).attr('data', current_product_sku_ele.attr('product_handle')).attr('product_url', "/products/"+current_product_sku_ele.attr('product_handle')); 
        $res_html.find('div[ product_handle="'+product_handle_string+'"]').attr('product_handle', product_handle_string+'|'+current_product_sku_ele.attr('product_handle'));
      }
    }else{
      if(typeof data[section_filename] != 'undefined' && data[section_filename]){
          for(var i=0; i<related_product_handle_arr.length; i++){
              if(data[section_filename].indexOf('/'+related_product_handle_arr[i]) !== -1){
                product_handle_contain = 1;
              }
          }
      }
    }
  });
  
  //ele_obj.before($res_html);
  if(product_handle_contain == 1){
    var img_box_index = 0;
    $res_html.find('.image-list .image-list-item').each(function(){
      let item_product_handle = $(this).attr('product_handle');
      let item_product_handle_show = 0;
      for(var i=0; i<related_product_handle_arr.length; i++){
        if(item_product_handle.indexOf(related_product_handle_arr[i]) !== -1){
          item_product_handle_show = 1;
        }
      }
      if(item_product_handle_show == 0){
          $res_html.find($(this)).remove();
      }else{
        $(this).find('.img-box').attr('index', ++img_box_index);
      }
    });
    img_box_index = 0;
    $res_html.find('.image-list-slick .img-box-outer').each(function(){
        let item_product_handle = $(this).find('.img-box').attr('product_handle');
        let item_product_handle_show = 0;
        for(var i=0; i<related_product_handle_arr.length; i++){
          if(item_product_handle.indexOf(related_product_handle_arr[i]) !== -1){
            item_product_handle_show = 1;
          }
        }
        if(item_product_handle_show == 0){
            $res_html.find($(this)).remove();
        }else{
          $(this).attr('index', ++img_box_index);
        }
    });
    ele_obj.before($res_html);
    if($('.instagram_product_handle').length>0){
      $('.section-instagram-gallery .instagram_gallery_title').html('Find #SUCSSRICH In Media');
      $('.engoj_find_img_div.instagram_product_handle').each(function() {
        var product_handle_str = $(this).attr('data');
        var product_info = getProductInfo(product_handle_str, $(this), getInstagramProductInfo);
      });
      instagramGalleryMethod();
    }
  }
}
function ajaxGetSections(section_filename,ele_obj,callback){
  if (section_filename && ele_obj && callback) {
    $.ajax({
        url: '/?sections='+section_filename,
        type: 'GET',
        dataType: "json",
        cache: false,
        success: function(data) {
          callback(section_filename,ele_obj, data);
        },
        error: function(data) {
          console.log('section', data);
        }
    });
  }
}
function getProductInfo(product_handle, ele_obj, callback) {
  if (product_handle) {
      try{
        jQuery.ajax({
            dataType: "json",
            url: "/products/" + $.trim(product_handle) + ".js",
            cache: false,
            success: function(data) {
                callback && callback(ele_obj, data);
            },
            error: function() {

            }
        });
      } catch (e) {
       console.log(e);
      }
    }
}

function getInstagramProductInfo(ele_obj, product_info){
  /*
    if(ele_obj && ele_obj.length && product_info && (typeof product_info.featured_image) != 'undefined' && product_info.featured_image){
        $(ele_obj).find('a').attr('href', product_info.url).attr('title',product_info.title);
        $(ele_obj).find('img.img-responsive').attr('src',product_info.featured_image+'&width=200').attr('title',product_info.title).attr('alt',product_info.featured_image.alt);
        if(product_info.compare_at_price == null){
            $(ele_obj).find('span.price').html(Shopify.formatMoney(product_info.price, window.money_format));
        }else{
            $(ele_obj).find('span.price').html(Shopify.formatMoney(product_info.price, window.money_format));
            $(ele_obj).find('s.price-old').html(Shopify.formatMoney(product_info.compare_at_price, window.money_format));
        }
    }
  */
  if(ele_obj && ele_obj.length && product_info && (typeof product_info.featured_image) != 'undefined' && product_info.featured_image){
    if(product_info.variants.length > 0){
      let show_variant_index = 0;
      for(variants_i=0; variants_i<product_info.variants.length; variants_i++){
          if(product_info.variants[variants_i].available){
            show_variant_index = variants_i;
            break;
          }
      }
      let show_current_handle = $(ele_obj).attr('data');
      for(variants_i=0; variants_i<product_info.variants.length; variants_i++){
          if(product_info.variants[variants_i].available && show_current_handle.indexOf(product_info.variants[variants_i].id) != -1){
            show_variant_index = variants_i;
            break;
          }
      }
      $(ele_obj).find('.engoj_find_right_title').html(product_info.variants[show_variant_index].name);
      $(ele_obj).find('a').attr('href',product_info.url+'?variant='+product_info.variants[show_variant_index].id).attr('title',product_info.variants[show_variant_index].name);
      $(ele_obj).find('input[name="id"]').val(product_info.variants[show_variant_index].id);
      $(ele_obj).find('input[name="product-id"]').val(product_info.id);
      if(1||product_info.variants[show_variant_index].featured_image == null){
          $(ele_obj).find('img.img-responsive').attr('src',product_info.featured_image+'&width=200').attr('srcset',product_info.featured_image+'&width=200').attr('alt',product_info.title).attr('title',product_info.title);
      }else{
          $(ele_obj).find('img.img-responsive').attr('src',product_info.variants[show_variant_index].featured_image.src+'&width=200').attr('srcset',product_info.variants[show_variant_index].featured_image.src+'&width=400').attr('alt',product_info.title).attr('title',product_info.title);
      }
      if(product_info.variants[show_variant_index].compare_at_price == null){
          $(ele_obj).find('span.price').html(Shopify.formatMoney(product_info.variants[show_variant_index].price, window.money_format));
      }else{
          $(ele_obj).find('span.price').html(Shopify.formatMoney(product_info.variants[show_variant_index].price, window.money_format));
          $(ele_obj).find('s.price-old').html(Shopify.formatMoney(product_info.variants[show_variant_index].compare_at_price, window.money_format));
      }
    }
  }
}
function ajaxAddCartByForm(form_selector){
    $(form_selector).on('submit', function(event) {
      event.preventDefault(); // prevent default form submission
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $(this).serialize(),
        dataType: 'json',
        success: function(line_item) {
          console.log(12, line_item);
          let mycart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if((typeof line_item) != 'undefined'){
            mycart.renderContents(line_item);
            if (mycart && mycart.classList.contains('is-empty')) mycart.classList.remove('is-empty');
          }
        },
        error: function(data) {
          console.log(22, data);
        }
      });
    });
}
function copyMethod (spu_no) {
    try {
         const newInput = document.createElement("input");
         newInput.value = spu_no;
         document.body.appendChild(newInput);
         newInput.select();
         document.execCommand("Copy");
         newInput.remove();
         showCustomModal();
     } catch (e) {
       console.log(e);
     }
}
function showCustomModal() {
    setTimeout(function () {
        hideCustomModal();
    }, 2000);
}
function hideCustomModal() {
   $('.ant-message').css('display', 'none');
   $('.coupon-copy-btn').text('Copy');
}

function klarnaModal() {
  $(document).on('click', '.klarna-message-model .klarna-message-model-payment-close', function(e) {
    $('.klarna-message-model').css('display', 'none');
    $('body').removeClass('cartover');
  })
  
  $(document).on('click', '.klarna-message-model .payment-close-span', function(e) {
    $('.klarna-message-model').css('display', 'none');
    $('body').removeClass('cartover');
  })
  
  $(document).on('click', '.klarna-message-block-view .klarna-message-link', function(e) {
    $('.klarna-message-model').css('display', 'flex').css('width', $(window).width()).css('height', $(window).height());
    $('body').addClass('cartover');
  })
}

function setCookie(name, value, hours) { // 设置cookie
  var d = new Date();
  d.setTime(d.getTime() + (hours * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function getCookie(name) {// 读取cookie
  var cname = name + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(cname) === 0) {
      return c.substring(cname.length, c.length);
    }
  }
  return "";
}

function slickObject(dom, pcNum=1, mobileNum=1, optionField= {} ) {
  const slickDom = dom.slick({
    slidesToShow: $(window).width() > 990 ? pcNum : mobileNum,
    slidesToScroll: 1,
    dots: false,
    arrows:  true,
    infinite: true,
    vertical: false,
    verticalSwiping: false,
    centerMode: $(window).width() > 990 ? false : true,
    centerPadding: $(window).width() > 990 ? '0px' : '3px',
    prevArrow:'<button type="button" class="prev-slide" aria-label="prev"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    nextArrow:'<button type="button" class="next-slide" aria-label="next"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    focusOnSelect: false,
    ...optionField
  })
  return slickDom
}

function mobileFeaturedIcon() {
  const option ={
    arrows: false,
    autoplay: true,
    slidesToScroll: 3,
    infinite: true 
  }
 $(window).width() < 990 && slickObject($('.template-index .featured-in .featured-icon .block-top-link'), 1, 3, option);
}
function showTotalData(data, flag){
    console.log(data);
    if(data.items.length<=0){
      return;
    }
    if(data.total_discount > 0) {
      var code_list = [];
      if(data.cart_level_discount_applications.length>0){
        data.cart_level_discount_applications.forEach(i => {
          if((typeof i.discount_application) != 'undefined'){
            code_list.push(i.discount_application.title.toUpperCase());
          }else if((typeof i.title) != 'undefined'){
            code_list.push(i.title.toUpperCase());
          }
        });
      }else if(data.discount_codes.length>0){
        data.discount_codes.forEach(i => {
          if(i.applicable == true){
            if((typeof i.code) != 'undefined'){
              code_list.push(i.code.toUpperCase());
            }else if((typeof i.title) != 'undefined'){
              code_list.push(i.title.toUpperCase());
            }
          }
        });
      }
      console.log("code_list:"+code_list.join(","));
      var code_html = "";
      code_list.forEach(item_c => {
        code_html += '<span class="applied-discount-code-wrapper" style="display: inline-flex;" data="'+item_c+'"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" aria-hidden="true"><path stroke-linecap="round" d="M7.284 1.402h4.964a.35.35 0 0 1 .35.35v4.964a.7.7 0 0 1-.205.495L7.49 12.115a.7.7 0 0 1-.99 0L1.885 7.5a.7.7 0 0 1 0-.99L6.79 1.607a.7.7 0 0 1 .495-.205Z"></path><circle cx="9.1" cy="4.9" r="0.7"></circle><path stroke-linecap="round" stroke-linejoin="round" d="M9.102 4.897h-.005v.005h.005v-.005Z"></path></svg><span class="applied-discount-code-value" data="'+item_c+'">'+item_c+'</span><a href="javascript:void(0);" id="clear-discount-btn" data="'+item_c+'">X</a></span>';
      });
      $(".applied-discount-code").html(code_html);
      $(".applied-discount-code2").removeClass('hide');
      $(".cart-items-subtotal").html(Shopify.formatMoney(data.items_subtotal_price, settings_new.moneyFormat));
      $(".cart-items-discount").html("-" + Shopify.formatMoney(data.total_discount, settings_new.moneyFormat));
      let cart_total = data.total_price + window.shipping_fee;
      $(".cart_total_money").html(Shopify.formatMoney(data.total_price, settings_new.moneyFormat));
    } else {
      $(".applied-discount-code").html("");
      $(".applied-discount-code2").addClass('hide');
      if(flag){
        $(".discount-code-error").html("Please Enter Valid Coupon Code.");
      }
      $(".cart-items-subtotal").html(Shopify.formatMoney(data.items_subtotal_price, settings_new.moneyFormat));
      $(".cart-items-discount").html("-" + Shopify.formatMoney(data.total_discount, settings_new.moneyFormat));
      let cart_total = data.total_price + window.shipping_fee;
      $(".cart_total_money").html(Shopify.formatMoney(cart_total, settings_new.moneyFormat));
    }
    try{
          if($('#cart-items-discount-save-price').length > 0) {
            var cart_items_discount_save_price = parseInt($.trim($('#cart-items-discount-save-price').attr('value')));
            if(cart_items_discount_save_price > 0) {
              data.total_discount = data.total_discount + cart_items_discount_save_price;
            }
          }
      } catch (e) {
        console.log(e);
      }
      if($(".cart_total_savings").length>0){
        if(data.total_discount > 0){
          $(".cart_total_savings").html("Savings: " + Shopify.formatMoney(data.total_discount, settings_new.moneyFormat));
          savingSelector.classList.remove('hide');
        }else{
          savingSelector.classList.add('hide');
        }
      }
  }
  function clearDiscount(current_code) {
    $(".discount-code-error").html("");
    $(".applied-discount-code .applied-discount-code-wrapper").each(function(){
      console.log($(this).attr('data')+"--"+current_code);
      if($(this).attr('data') == current_code){
        $(this).remove();
      }
    });
    var code_arr = [];
    $(".applied-discount-code .applied-discount-code-wrapper").each(function(){
      code_arr.push($(this).attr('data'));
    });
    if(code_arr.length>0){
      var code_temp = code_arr.join(",");
    }else{
      var code_temp = "none"
    }
    $(".enj-minicart-ajax .total-info-order .cart-items-subtotal").html("");
    $(".enj-minicart-ajax .total-info-order .cart-items-discount").html("");
    $(".enj-minicart-ajax .prod").addClass("noDiscount");
    /*fetch("/discount/CLEAR").then(function(data){*/
    fetch("/checkout?discount="+code_temp).then(function(data){
      fetch('/cart.js', {})
        .then(function(res){return res.json();})
        .then(function(data){
          showTotalData(data,0);
        })
    })
  }
  function applyDiscount(code) {
    if($.trim(code).length <= 0){
        return;
    }
    code = code.toUpperCase();
    var code_arr = [];
    $(".applied-discount-code .applied-discount-code-wrapper").each(function(){
      code_arr.push($(this).attr('data'));
    });
    if(code_arr.indexOf(code) !== -1){
        return;
    }
    code_arr.push(code);
    var code_temp = code_arr.join(",");
    $(".discount-code-error").html("");
    $(".apply-discount-btn").addClass('btn--loading').html("Apply <div class='loader'></div>");
    $(".apply-discount-btn").css("pointerEvents", "none");
    /*fetch(`/discount/${code_temp}`)*/
    fetch("/checkout?discount="+code_temp)
    .then(function() {
      // After the discount code has been applied, force the cart to update so the discount is visible
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: {},
        }),
      }).then(function(res){
        return res.json();
      }).then(function(data) {
        showTotalData(data,1);
        $(".apply-discount-btn").html("Apply");
      })
    })
    .then(function() {
      // 更新购物车显示（如果需要）
      console.log('Please Enter Valid Coupon Code.');
    })
    .catch(function(error) {
      console.error('Error--:', error);
    }).finally(function(params) {
      $(".apply-discount-btn").removeClass('btn--loading').html("Apply");
      $(".apply-discount-btn").css("pointer-events",'all')
    });
  }

  function getShippingRate(){
    fetch('/cart/shipping_rates.json', {
        method: 'POST',
        body: JSON.stringify({
          shipping_address: {
            zip: "77523",
            country: "United States",
            province: "Texas"
          }
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
      .then(response => response.json())
      .then(function(parsedState) {
        console.log('shipping rates: ', parsedState);
        if (parsedState && parsedState.shipping_rates && parsedState.shipping_rates.length > 0 && parsedState.shipping_rates[0].price >= 0) {
          window.shipping_fee = parsedState.shipping_rates[0].price * 100;
          var cart_shipping_fee_money = document.querySelectorAll('.cart_shipping_fee_money');
          for (var i = 0; i < cart_shipping_fee_money.length; i++) { 
            cart_shipping_fee_money[i].innerHTML = Shopify.formatMoney(window.shipping_fee, settings_new.moneyFormat);
          }
          let cart_total = 0;
          if($('.template-cart').length>0){
            cart_total = parseInt($('.cart__footer .cart_total_money').attr('data-price')) + window.shipping_fee;
          }else{
            cart_total = parseInt($('.cart_total_money').attr('data-price')) + window.shipping_fee;
          }
          $('.cart_total_money').html(Shopify.formatMoney(cart_total, settings_new.moneyFormat));
        }
      })
      .catch(e => console.error(e));
  }
  function footerMenuMobile() {
      if ($(window).width() < 990) {
        $('.footer .footer-block .footer-block__details-content').hide();
        $(".footer-block--newsletter .newsletter-form__field-wrapper .field .field__label").text('Enter your email');
        const testName = $('.footer .footer-block .footer-block__heading span');
        for (let i = 0 ; i < testName.length; i ++) {
          if ($(testName[i]).text() == 'Support') {
            $(testName[i]).parents('.footer-block__heading').siblings('.footer-block__details-content').show();
            $(testName[i]).parents('.footer-block__heading').addClass('open');
          }
        }
      }
      $(document).on('click', '.footer h2.footer-block__heading', function(e) {
        if($(window).width() < 990 ) {
          const isHava =  $(this).hasClass('open');
          if(!isHava) {
            $(this).addClass('open').siblings('.footer-block__details-content').show();
          } else {
            $(this).removeClass('open').siblings('.footer-block__details-content').hide();
          }
        }
      })

      const productDom = $(".product .product__info-wrapper .product__accordion summary h2.accordion__title");
      for(let i = 0; i < productDom.length; i ++) {
        const textName = $(productDom[i]).text();
        if (textName.indexOf('Dimensions & Specifications') > -1) {
            $(productDom[i]).parents('details').find('.descriptionOuterBox').show();
            $(productDom[i]).parents('details').find('.accordion__content').css('max-height', '600px');
        }
        if (textName.indexOf('Quick Know') > -1) {
          $(productDom[i]).parents('summary').click();
        }
      }
  }
  function setBannerHeight(){ // 通过图片比例来计算渲染后的高度
    const domArr =  $('.banner');
    //主banner宽高比1000/439, 默认为170/69
    for(let i = 0; i < domArr.length; i++ ) {
      const id = $(domArr[i]).attr('id')
      if (id.indexOf('image_banner_IndexBanner')> -1) {
        bannerHeight($(domArr[i]), 439, 1000);
      }
      else if (id.indexOf('image_banner_7MBCdM')> -1) {
        bannerHeight($(domArr[i]), 1, 2);
      }
      else if (id.indexOf('image_banner_ctrLwN')> -1) {
        bannerHeight($(domArr[i]), 107, 340);
      }
      else {
        bannerHeight($(domArr[i]), 69, 170);
      }
    }
  }

  function bannerHeight($dom, h, w) {
    const bannerWidth = $dom.width();
    // 主图banner宽高比 1000:439
    const height = parseInt(Number(bannerWidth)*h/w);
    $dom.css('min-height', height+'px');
  }
